export default {
    add_new_topic: "Adicionar novo tópico",
    confirm_delete_reply: "Tem certeza que deseja apagar a sua resposta?",
    confirm_delete_topic: "Tem certeza que deseja apagar este tópico?",
    delete_reply: "Apagar resposta",
    delete_topic: "Apagar este tópico",
    delete: "Apagar",
    edit: "Editar",
    error_changing_answer_status: "Erro ao alterar o status da resposta",
    error_changing_topic_status: "Erro ao alterar o status do tópico",
    error_deleting_reply: "Erro ao apagar a resposta",
    error_deleting_topic: "Erro ao apagar este tópico",
    error_editing_reply: "Erro ao editar a resposta",
    error_editing_topic: "Erro ao editar o tópico",
    in_this_course: "nesse curso",
    reply_deleted: "Resposta apagada",
    reply_edited: "Resposta alterada",
    search_topic: "Buscar tópico",
    there_are_no_topics_in_this_course_yet: "Ainda não existem tópicos nesse curso",
    topic_added_successfully: "Tópico adicionado com sucesso",
    topic_deleted: "Tópico apagado!",
    topic_edited: "Tópico editado",
    topic_is_closed: "Este tópico está fechado e não aceita mais respostas.",
    topic_plural: "tópicos",
    topic: "tópico",
}
